import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from "../..";

/**
 * Table Rich
 */
import { jsx as _jsx } from "react/jsx-runtime";
var TableRichPopupFilter = function TableRichPopupFilter(props) {
  var items = props.items,
    filters = props.filters,
    onFilterChange = props.onFilterChange;
  var _useState = useState([]),
    filterOptions = _useState[0],
    setFilterOptions = _useState[1];
  // const [filterValues,setFilterValues] = useState([])

  useEffect(function () {
    // création du tableau de valeurs possibles
    var filterOptionsTmp = [];
    items.map(function (item) {
      return _.map(item, function (value, key) {
        if (key === filters.column && _.findIndex(filterOptionsTmp, function (filter) {
          return filter.value === value;
        }) === -1) {
          filterOptionsTmp.push({
            key: value,
            value: value,
            text: value
          });
        }
      });
    });
    setFilterOptions(filterOptionsTmp);
  }, [items, filters]);
  var handleChangeFilter = function handleChangeFilter(event, data) {
    // filtre la colonne
    var _ref = data || {},
      value = _ref.value;
    if (onFilterChange) {
      onFilterChange(filters.column, value);
    }
  };
  return /*#__PURE__*/_jsx(Dropdown, {
    placeholder: "S\xE9lectionner un filtre...",
    name: "filtre",
    multiple: true,
    className: "dropdownFiltre",
    search: true,
    selection: true,
    options: filterOptions,
    onChange: handleChangeFilter,
    value: filters.filterValues,
    noResultsMessage: "Aucun r\xE9sultat"
  }, "filtre");
};
TableRichPopupFilter.handledProps = ["filters", "items", "onFilterChange"];
TableRichPopupFilter.propTypes = {
  onFilterChange: PropTypes.func,
  filters: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])),
  items: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]))
};
TableRichPopupFilter.defaultProps = {
  onFilterChange: null,
  filters: [],
  items: []
};
export default TableRichPopupFilter;